import api from './api';

const getClients = () => {
  return api.get('/clients');
};

const createClient = (clientData) => {
  return api.post('/clients', clientData);
};

const updateClient = (oldName, newName) => {
  return api.put(`/clients/${oldName}`, { new_name: newName });
};

const deleteClient = (clientName) => {
  return api.delete(`/clients/${clientName}`);
};
const clientService = {
  getClients,
  createClient,
  updateClient,
  deleteClient,
};

export default clientService;